<script>
import JetDatepicker from '@/Jetstream/Datepicker.vue';
import JetSelect from '@/Jetstream/Select.vue';
import { DateTime } from 'luxon';

export default {
    name: 'AssetCadenceConfiguration.vue',
    props: ['modelValue', 'config'],
    components: { JetDatepicker, JetSelect },
    data() {
        return {
            cadence: {
                unit: null,
                value: null,
                startDate: null,
            },
        };
    },
    computed: {
        options() {
            return this.config.options;
        },
        isConfigurable() {
            return this.cadence.unit && this.cadence.unit !== 'never';
        },
        cadenceOptions() {
            return this.options.map((option) => ({
                label: option.label,
                value: option.unit,
            }));
        },
        payload() {
            return Object.assign(
                {},
                {
                    unit: this.cadence.unit || 'never',
                    value: this.cadence.value ? parseInt(this.cadence.value) : null,
                    startDate: this.cadence.startDate?.toFormat('yyyy-MM-dd') || null,
                },
            );
        },
        rangeOptions() {
            let range = this.options.find((option) => option.unit === this.cadence.unit)?.range;

            return range
                ? range.map((val) => ({
                      label: this.trans(`cadence.unit.${this.cadence.unit}.value`, {
                          '%d': val,
                      }),
                      value: val.toString(),
                  }))
                : [];
        },
    },
    methods: {
        updateCadenceUnit(unit) {
            if (unit === 'never') {
                this.cadence.value = null;
                this.cadence.startDate = null;
            } else {
                this.cadence.value = this.rangeOptions.first()?.value ?? null;
                this.cadence.startDate = this.cadence.startDate ?? DateTime.now();
            }

            this.$emit('update', this.payload);
        },
    },
};
</script>

<template>
    <div class="d-md-flex" style="gap: 10px">
        <jet-select
            v-model="cadence.unit"
            :horizontal="false"
            :inline="true"
            :options="cadenceOptions"
            class="mb-md-0"
            @update:model-value="updateCadenceUnit($event)"
        />
        <jet-select
            v-model="cadence.value"
            :disabled="!isConfigurable"
            :horizontal="false"
            :inline="true"
            :options="rangeOptions"
            class="mb-md-0"
            @update:model-value="$emit('update', payload)"
        />
        <jet-datepicker
            v-model="cadence.startDate"
            :deletable="false"
            :disabled="!isConfigurable"
            :horizontal="false"
            :inline="true"
            :placeholder="trans('cadence.start_date.label')"
            color="tertiary"
            form-group-classes="mb-0"
            @update:model-value="$emit('update', payload)"
        />
    </div>
</template>
